import { TifSeatIcon } from '@/components/icons/tif/TifSeatIcon';
import { tenantSelector } from '@/features/configuration/configurationSelector';
import { useSelector } from '@/store/utils';
import { Icons, type IconProps } from '@packages/webshop-design-system';

/** Seat pictogram; uses TIF branding for `tifrance` (BR-57773). */
export const SeatPictogram = (props: IconProps) => {
  const { value: tenant } = useSelector(tenantSelector);
  const Icon = tenant === 'tifrance' ? TifSeatIcon : Icons.seat;

  return <Icon {...props} />;
};
